import { store } from '../store'
import { loggerNamespace } from '../lib/Logger'
import { create as createConfig, TSingleCatalogConfig } from '../models/SingleCatalogConfig'
import { create as createItem, TSingleCatalogItem } from '../models/SingleCatalogItem'
import { AbstractCatalogService, TCatalogType } from './AbstractCatalogService'

export class SingleCatalogService extends AbstractCatalogService<TSingleCatalogConfig, TSingleCatalogItem>{
  public type: TCatalogType = 'single'
  public store = store.singleCatalog
  protected logger = loggerNamespace('SingleCatalogService')
  protected createConfig = createConfig
  protected createItem = createItem
}

const singleCatalogService = new SingleCatalogService()
export { singleCatalogService }
